import SidebarInstance from '@js/modules/public/rankings/institutional/view/components/sidebar';
import {
    appendQueryParam, removeQueryParam,
} from '@js/helpers/location';
import initCompareRowsListeners from '@js/components/compareRows';
import {initRankingRowShare, highlightViewedOrganization} from '@js/components/shareRankingResult';
import initAppliedFiltersListeners from '@js/modules/public/rankings/institutional/view/components/appliedFilters';
import {initLockFilterYear, initSelectsWithLiveSearch} from '@js/modules/public/rankings/institutional/view/helpers';
import {getRefreshRankingPageParams, refreshRankingPage} from '@js/modules/public/rankings/subject/view/helper';
import {initScrollRankingPage} from "@js/components/ranking/scrollRankingPage";

$(() => {
    initFiltersListeners();
    configureCompareRows();
    initAppliedFiltersListeners();
    initRankingRowShare($('.ranking-row-share'));
    highlightViewedOrganization();
    initSelectsWithLiveSearch();
    initScrollRankingPage();
    initLockFilterYear();
    const sidebar = new SidebarInstance('#sidebar_inner');
});

function configureCompareRows() {
    const storageKey = 'compare.russian_step_in_gpr.organizations';
    const $resultCompareButtonParent = $('.ranking-results');
    const refreshPageParamsFn = () => {
        return getRefreshRankingPageParams(false);
    };
    initCompareRowsListeners(storageKey, $resultCompareButtonParent, refreshPageParamsFn);
}

function initFiltersListeners() {
    const $wrapper = $('body');
    const $filters = $wrapper.find('#filters');
    $filters
        .on('change', '#filters select.filter-control, #filters [name="ranking"], [name="countries_union"]', function () {
            const $changedControl = $(this);
            const appendCompareOrganizationParams = $changedControl.attr('id') !== 'name';
            refreshRankingPage(appendCompareOrganizationParams, null);
        })
        .on('change', '[name="ranking"], [name="year"], [name="ugs"], [name="name"], [name="organization"], [name="country"], [name="league"]', refreshRankingPage)
        .on('change', '[name="group_mode_subject"]', () => {
            const $organizationSelect = $('select.organization-filter');
            if ($organizationSelect.val()) {
                const $ugsSelect = $('#ugs');
                let queryParams = $('form#filters').serialize();
                if ($ugsSelect.length) {
                    const organizationId = $organizationSelect.find('option:selected').attr('data-id');
                    queryParams = removeQueryParam(queryParams, 'name');
                    queryParams = appendQueryParam(queryParams, 'organization', organizationId);
                } else {
                    const organizationName = $organizationSelect.find('option:selected').attr('data-name');
                    queryParams = removeQueryParam(queryParams, 'organization');
                    queryParams = appendQueryParam(queryParams, 'name', organizationName);
                }
                refreshRankingPage(false, queryParams);
            } else {
                refreshRankingPage(false);
            }
        });
    const $modalFiltersForm = $('#modal-filter-form');
    $('.filters__modal-footer')
        .on('click', '#btnFilter', () => {
            refreshRankingPage(false, $modalFiltersForm.serialize());
        });
    $modalFiltersForm
        .on('change', '[name="group_mode_subject"]', function () {
            const $modalStatus = $modalFiltersForm.find('#modalStatus');
            $modalStatus.val(true);
            toggleGroupModeSubjectFilter($(this));
        });
    const $activeModeSubjectFilter = $('.filters-radio-group').find('.active [name="group_mode_subject"]');
    if (parseInt($activeModeSubjectFilter.val(), 10)) {
        $filters
            .on('change', '#filters [name="ranking"]', () => {
                refreshRankingPage(false, null);
            })
            .on('change', '[name="mode"]', refreshRankingPage);
    }
    const $sort = $wrapper.find('#sort');
    $sort
        .on('change', '[name="sort_by"]', refreshRankingPage)
}

function toggleGroupModeSubjectFilter($selector) {
    const $form = $selector.closest('form');
    const $organizationSelect = $form.find('select.organization-filter');
    if ($organizationSelect.val()) {
        const $ugsSelect = $form.find('#ugs');
        let queryParams = $form.serialize();
        if ($ugsSelect.length) {
            const organizationId = $organizationSelect.find('option:selected').attr('data-id');
            queryParams = removeQueryParam(queryParams, 'name');
            queryParams = appendQueryParam(queryParams, 'organization', organizationId);
        } else {
            const organizationName = $organizationSelect.find('option:selected').attr('data-name');
            queryParams = removeQueryParam(queryParams, 'organization');
            queryParams = appendQueryParam(queryParams, 'name', organizationName);
        }
        refreshRankingPage(false, queryParams);
    } else {
        refreshRankingPage(false);
    }
}
